import { ETextImprove } from '@common/enums/text-improve.enum';
import { ETextTone } from '@common/enums/text-tone.enum';
import { ETextLanguage } from '@common/enums/text-language.enum';

export const textImproveList: {
    label: ETextImprove;
    value: string;
    text: string;
}[] = [
    {
        label: ETextImprove.ADD_CREATIVITY,
        text: 'ai_add_creativity',
        value: 'get creative with text',
    },
    {
        label: ETextImprove.CORRECT_MISTAKES,
        text: 'ai_correct_errors',
        value: 'correct errors in the text',
    },
    {
        label: ETextImprove.MAKE_LONGER,
        text: 'ai_make_longer',
        value: 'make text longer',
    },
    {
        label: ETextImprove.MAKE_SHORTER,
        text: 'ai_make_shorter',
        value: 'make text shorter',
    },
    {
        label: ETextImprove.SIMPLIFY,
        text: 'ai_simplify',
        value: 'simplify the text',
    },
];
export const textToneList: {
    label: ETextTone;
    value: string;
    text: string;
}[] = [
    {
        label: ETextTone.BUSINESS,
        text: 'ai_business_tone',
        value: 'in a formal tone',
    },
    {
        label: ETextTone.CEREMONIAL,
        text: 'ai_ceremonial_tone',
        value: 'in a ceremonial tone',
    },
    {
        label: ETextTone.FUNNY,
        text: 'ai_fun_tone',
        value: 'in a fun tone',
    },
    {
        label: ETextTone.FRIENDLY,
        text: 'ai_friendly_tone',
        value: 'in a friendly tone',
    },
];

export const textLangList: {
    label: ETextLanguage;
    value: string;
    text: string;
}[] = [
    {
        label: ETextLanguage.EN,
        text: 'ai_translate_to_en',
        value: 'translate text into english',
    },
    {
        label: ETextLanguage.UA,
        text: 'ai_translate_to_ua',
        value: 'translate text into ukrainian',
    },
    {
        label: ETextLanguage.ES,
        text: 'ai_translate_to_es',
        value: 'translate text into spanish',
    },
    {
        label: ETextLanguage.PT,
        text: 'ai_translate_to_pt',
        value: 'translate text into portuguese',
    },
    {
        label: ETextLanguage.TR,
        text: 'ai_translate_to_tr',
        value: 'translate text into turkish',
    },
    {
        label: ETextLanguage.FR,
        text: 'ai_translate_to_fr',
        value: 'translate text into french',
    },
    {
        label: ETextLanguage.DE,
        text: 'ai_translate_to_de',
        value: 'translate text into german',
    },
    {
        label: ETextLanguage.IT,
        text: 'ai_translate_to_it',
        value: 'translate text into italian',
    },
    {
        label: ETextLanguage.PL,
        text: 'ai_translate_to_pl',
        value: 'translate text into polish',
    },
    {
        label: ETextLanguage.RU,
        text: 'ai_translate_to_ru',
        value: 'translate text into russian',
    },
];
